import * as React from 'react';
import { IDataEntity } from '../../models';
import { isNullOrUndefined } from "../../utils";
import * as moment from "moment";
import { NumberFormat } from "../../assets/NumberFormat/NumberFormat";
import { IPageProperties, IExplorerProperties } from "../../models";
import { ArrowIndicator, Disclaimer } from "../../assets";

const FaAngleDown = require('react-icons/lib/fa/angle-down');
const styles = require('../FundPages/Fundpages.pcss');
const internalStyles = require('./ExplorerHistoricalPricesPDF.pcss');
const FaPDF = require('react-icons/lib/fa/file-pdf-o');
const FaDownload = require('react-icons/lib/fa/download');

interface IState {
    visible: boolean;
}

function getSortedDataInRange(timeseriesData, shareClass, startDate, endDate, valueProperty) {
    if (timeseriesData) {
        let rows = [];
        let sortedPrices = timeseriesData.values.sort((a, b) => {
            const aValue = new Date(a.date).getTime();
            const bValue = new Date(b.date).getTime();
            return bValue - aValue;
        });
        for (let values of sortedPrices) {
            if (moment(values.date).isBetween(startDate, endDate, null, '[]')) {
                let row = [
                    shareClass.properties["fund_name"],
                    shareClass.properties.shareclass_name,
                    timeseriesData.ccy,
                    shareClass.clientCode,
                    moment(values["date"]).format("DD.MM.YYYY"),
                    values[valueProperty]
                ];
                rows.push(row);
            }
        }
        return rows
    }
}

export class ExplorerHistoricalPricesPDF extends React.Component<IExplorerProperties, IState>{
    constructor(props) {
        super(props);
    }

    getRows(assetClass, shareClass, historicalPricesType) {
        let { appParams } = this.props;
        let { startdate, enddate, sort, productrange } = appParams;
        let rows = [];
        let historicalSharePricesData = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
        let historicalNavData = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
        let clientCode = shareClass.properties.fund_key;
        let clientCodeList = ['CIIT'];
        let clientTypes;
        let clientTypeCheck;
        let clientTypesList = ['Discretionary Wealth', 'Independent Financial Advisor'];
        if (clientCodeList.indexOf(clientCode) > -1) {
            clientTypes = shareClass.properties.client_types;
            clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1);
        }

        if (!isNullOrUndefined(historicalNavData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck && this.useHistoricalNavPricesData(historicalPricesType)) {
            let [historicalNavPrices] = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
            if (moment(startdate).format("YYYY-MM-DD") === "Invalid date") {
                startdate = "1970-01-01"
            }
            rows = getSortedDataInRange(historicalNavPrices, shareClass, startdate, enddate, "value");
        } else if (!isNullOrUndefined(historicalSharePricesData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck && this.useHistoricalSharePricesData(historicalPricesType)) {
            let [historicalPrices] = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
            rows = getSortedDataInRange(historicalPrices, shareClass, startdate, enddate, "shareclass_price");
        } else {
            let [historicalPrices] = shareClass.timeseries.filter(item => item.code === "historical_prices");
            if (historicalPrices) {
                let sortedPrices = historicalPrices.values.sort((a, b) => {
                    const aValue = new Date(a.date).getTime();
                    const bValue = new Date(b.date).getTime();
                    return bValue - aValue;
                });
                for (let values of sortedPrices) {
                    if (moment(values.date).isBetween(startdate, enddate, null, '[]')) {
                        let row = [
                            shareClass.properties["fund_name"],
                            shareClass.properties.shareclass_name,
                            historicalPrices.ccy,
                            shareClass.clientCode,
                            moment(values["date"]).format("DD.MM.YYYY")
                        ];

                        if (assetClass === "Property" || productrange === "PPL") {
                            row.push(values["local_bid_price"], values["local_offer_price"]);
                        } else {
                            row.push(values["shareclass_price"]);
                        }
                        if (values["dealing_price_basis"]) {
                            row.push(values["dealing_price_basis"]);
                        }

                        rows.push(row);
                    }
                }
            }
        }
        rows.reverse();
        return rows;
    }

    showNavPriceColumn(historicalPricesType){
        const showNavPriceColumn = ["historical_nav_prices"];
        return (showNavPriceColumn.indexOf(historicalPricesType) > -1)
    }

    showPriceColumn(historicalPricesType){
        const showPriceColumn = ["historical_prices", "historical_share_prices", "default"];
        return (showPriceColumn.indexOf(historicalPricesType) > -1)
    }

    useHistoricalNavPricesData(historicalPricesType) {
        const useNavPriceData = "historical_nav_prices";
        return (useNavPriceData === historicalPricesType);
    }

    useHistoricalSharePricesData(historicalPricesType) {
        const useSharePriceData = "historical_share_prices";
        return (useSharePriceData === historicalPricesType);
    }

    setPdfHeader(historicalPricesType){
        switch(historicalPricesType){
            case "historical_prices":
                return <h1>Historical Prices</h1>
            case "historical_nav_prices":
                return <h1>Historic Nav</h1>
            case "historical_share_prices":
                return <h1>Historical Share Prices</h1>
            default:
                return <h1>Historical Prices</h1>
        }
    }

    render() {
        let { funds, disclaimers, appParams } = this.props;
        const historicalPricesType = appParams.historicalpricestype ? appParams.historicalpricestype : "default";
        let [fund] = funds.values.filter(item => item.shareClasses.length === 1);
        let isPPL = appParams.productrange === "PPL";
        if (!fund) {
            return null;
        }
        let disclaimer = <Disclaimer appParams={ appParams } disclaimer={ disclaimers["daily_prices_disclaimer"] } />;
        let rows = [];
        let [shareclass] = fund.shareClasses.filter(shareClass => shareClass.clientCode === appParams.isin);
        let historicalSharePricesData = shareclass.timeseries.filter(item => item.code === "historical_share_prices");
        let [historicalNavPrices] = shareclass.timeseries.filter(item => item.code === "historical_nav_prices");
        let clientCode = fund.clientCode;
        let clientCodeList = ['CIIT'];
        let clientTypes;
        let clientTypeCheck;
        let clientTypesList = ['Discretionary Wealth', 'Independent Financial Advisor'];
        if (clientCodeList.indexOf(clientCode) > -1) {
            clientTypes = shareclass.properties.client_types;
            clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1);
        }
        let historicalPrices;

        if (!isNullOrUndefined(historicalSharePricesData) && clientCodeList.indexOf(clientCode) > -1 && clientTypeCheck){
            historicalPrices = shareclass.timeseries.filter(item => item.code === "historical_share_prices")[0].values;
        } else {
            historicalPrices = shareclass.timeseries.filter(item => item.code === "historical_prices")[0].values;
        }
        rows = [...this.getRows(fund.properties["asset_class"], shareclass, historicalPricesType)];

        if (!funds.isDefaultState) {
            setTimeout(() => {
                window.status = "pdfdataloaded";
                console.log('window.status', window.status);
                global['docdone'] = true; //electron using exportPdf endpoint of FundPress
            }, 1000);
        }

        return (
            <div className={ internalStyles.printable }>
                <div className={ internalStyles.tableElement }>
                    <table>
                        <thead>
                            <tr className={ internalStyles.hackHeader }>
                                <th colSpan={ rows.length ? rows[0].length : 1}>
                                    <div className={ internalStyles.headerRow }>
                                        <div className={ internalStyles.logoHolder }>
                                            <img style={ { width: 'auto', height: '100px' } } src={ require('../../images/M&G_Investments.jpg') } />
                                        </div>
                                        <div className={ internalStyles.PageTitle }>
                                        {this.setPdfHeader(historicalPricesType)}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            <tr className={ styles.RowItems + ' ' + internalStyles.tableRow }>
                                <th>Fund Name</th>
                                <th className={ internalStyles.center }>Share Class</th>
                                <th className={ internalStyles.center }>Currency</th>
                                <th className={ internalStyles.center }>ISIN</th>
                                <th className={ internalStyles.center }>Date</th>
                                { (() => {
                                    if (fund.properties["asset_class"] !== "Property" && !isPPL && this.showPriceColumn(historicalPricesType)) {
                                        return <th className={ internalStyles.numberColumn }>Price</th>
                                    }
                                })() }
                                { (() => {
                                    if (shareclass.properties.fund_key === "CIIT" && this.showNavPriceColumn(historicalPricesType)) {
                                        return <th className={ internalStyles.numberColumn }>NAV Price</th>
                                    }
                                })() }
                                { (() => {
                                    if ((fund.properties["asset_class"] === "Property" || shareclass.properties.fund_key === "HIT") || isPPL) {
                                        return <th className={ internalStyles.numberColumn }>Bid Price</th>
                                    }
                                })() }
                                { (() => {
                                    if ((fund.properties["asset_class"] === "Property" || shareclass.properties.fund_key === "HIT") || isPPL) {
                                        return <th className={ internalStyles.numberColumn }>Offer Price</th>
                                    }
                                })() }
                                { (() => {
                                    if (historicalPrices.indexOf(price => price.hasOwnProperty('dealing_price_basis') > -1) && isPPL) {
                                        return <th className={ internalStyles.center }>Dealing Basis</th>
                                    }
                                })() }
                            </tr>
                        </thead>
                        <tbody>
                            { rows.map((row, index) => {
                                return (
                                    <tr key={ index } className={ styles.RowItems + ' ' + internalStyles.tableRow }>
                                        { row.map((item, i) => {
                                            return (<td key={ i } className={ typeof item === 'number' ? internalStyles.numberColumn : internalStyles.center }>{ item }</td>)
                                        }) }
                                    </tr>
                                );
                            }) }
                        </tbody>
                    </table>
                </div>
                <div className={ internalStyles.printDisclaimer }>
                    { disclaimer }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/ExplorerHistoricalPricesPDF/ExplorerHistoricalPricesPDF.tsx